import { render, staticRenderFns } from "./NautaAnnounce.vue?vue&type=template&id=628c854a&scoped=true"
import script from "./NautaAnnounce.vue?vue&type=script&lang=js"
export * from "./NautaAnnounce.vue?vue&type=script&lang=js"
import style0 from "./NautaAnnounce.vue?vue&type=style&index=0&id=628c854a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628c854a",
  null
  
)

export default component.exports